import { CoreState } from "../../state";

export namespace SportsbookBlockSelector {
	export const isSportsbookBlocked = (state: CoreState): boolean | undefined =>
		state.sportsbookBlock.isSportsbookBlocked;

	export const isPlayerProfileSelected = (state: CoreState): boolean | undefined =>
		state.sportsbookBlock.isPlayerProfileSelected;

	export const isSelectionPostponed = (state: CoreState): boolean | undefined =>
		state.sportsbookBlock.isSelectionPostponed;

	export const shouldChoosePlayerProfile = (state: CoreState): boolean =>
		state.sportsbookBlock.isPlayerProfileSelected === false && !state.sportsbookBlock.isSelectionPostponed;
}
